import axios from "axios";
import { apiBaseUrl } from "../contant";

const api = `${apiBaseUrl}/api`;

const clearAccessToken = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("theme");
  localStorage.removeItem("branch_id");
};

axios.defaults.baseURL = api;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    const branchId = localStorage.getItem("branch_id");

    config.headers["Authorization"] = `Bearer ${token}`;

    // add branch_id here
    if (branchId) {
      config.headers["branch_id"] = branchId;
    }

    config.headers["Accept"] = "application/json";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      clearAccessToken();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);
